// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AZd-","type":"styles_type__VMaB3","choices":"styles_choices__xMShm"};